export default {
  "NoticeAgreementsSettingContents.ReceiveTel": "電話でのご案内を受け取らない",
  "NoticeAgreementsSettingContents.ReceiveMail": "郵送でのご案内を受け取らない",
  "NoticeAgreementsSettingContents.AsteriskText1":
    "{asterisk}安心・安全にサービスをご利用いただくために、",
  "NoticeAgreementsSettingContents.AsteriskText2":
    "設定にかかわらずご案内を差し上げることがあります",
  "NoticeAgreementsSettingContents.ChangeButtonText": "上記の設定に変更する",
  "NoticeAgreementsSettingContents.BackButtonText": "前のページへ戻る",
}
